/* eslint-disable jira/naming/disallow-filenames */
import React from 'react';
import type ProjectSettingsServiceDeskAutomationCreateRuleType from '@jira/spa-apps__project-settings-service-desk-automation-create-rule/src/index.tsx';
import { LazyPage } from '@jira/platform__spa/src/view/lazy-page/index.tsx';
import { lazyForPaint, type LazyComponent } from '@atlassian/react-loosely-lazy';

export const LazyProjectSettingsServiceDeskAutomationCreateRule: LazyComponent<
	() => React.JSX.Element
> = lazyForPaint<typeof ProjectSettingsServiceDeskAutomationCreateRuleType>(
	() =>
		import(
			/* webpackChunkName: "async-project-settings-service-desk-automation-create-rule", jiraSpaEntry: "async-project-settings-service-desk-automation-create-rule" */ '@jira/spa-apps__project-settings-service-desk-automation-create-rule/src/index.tsx'
		),
);

const AsyncProjectSettingsServiceDeskAutomationCreateRule = (): React.JSX.Element => (
	<LazyPage
		Page={LazyProjectSettingsServiceDeskAutomationCreateRule}
		pageId="project-settings-automation-create-rule"
		shouldShowSpinner
	/>
);

export default AsyncProjectSettingsServiceDeskAutomationCreateRule;
